import { Button, CircularProgress, OsButtonProps } from 'opensolar-ui'
import React from 'react'

export type LoadingActionButtonProps = OsButtonProps & {
  loading?: boolean
}

const LoadingActionButton = React.forwardRef<HTMLButtonElement, LoadingActionButtonProps>(
  ({ loading = false, disabled, children, startIcon, ...buttonProps }, ref) => (
    <Button
      ref={ref}
      disabled={disabled || loading}
      startIcon={loading ? <CircularProgress size={20} color="inherit" /> : startIcon}
      {...buttonProps}
    >
      {children}
    </Button>
  )
)

LoadingActionButton.displayName = 'LoadingActionButton'

export default LoadingActionButton
